import { Injectable, NgZone, Renderer2, Component, TemplateRef } from '@angular/core';
import { DialogService, DialogCloseResult, DialogRef } from '@progress/kendo-angular-dialog';


@Injectable()
export class NotificationService {

  constructor(
    private zone: NgZone,
    private dialogService: DialogService,
    private dialogRef: DialogRef) { }

  public result;
  //private dialog;

  public showError(message: string) {
    this.zone.run(() => {
      let dialog = this.dialogService.open({
        title: 'Error.',
        content: message,
        actions: [
          { text: 'Close' }
        ],
        minWidth: 250
      });

      dialog.result.subscribe(result => {
        if (result instanceof DialogCloseResult) {
          console.log('close');
        } else {
          console.log('action', result);
        }
        this.result = JSON.stringify(result);
      });

      

    });
  }
}



// WEBPACK FOOTER //
// c:/Projects/YuDRIV/ServicesAPI/YuDriv-ServicesAPI/Enforcement/src/app/services/shared/notification.service.ts